import { render, staticRenderFns } from "./TagDeleteAction.vue?vue&type=template&id=68b88ee4"
import script from "./TagDeleteAction.vue?vue&type=script&lang=js"
export * from "./TagDeleteAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports